export default {
    detailModule: {
        deadline: 'Application deadline',
        location: 'Location',
        employmentType: 'Employment type',
        languageRequirements: 'Language requirements',
        workPermitRequirements: 'Work permit requirements',
        preferredEducationField: 'Preferred education field',
        preferredEducationLevel: 'Preferred education level',
        jobTags: 'Tags',
        apply: 'Apply now',
        verificationRequired: 'You need to verify your school e-mail to apply.',
        verificationRequiredHint:
            'You need to verify your school e-mail to apply',
        verificationPending: 'You have a pending verification at this school',
        verificationPendingHint:
            'You have a pending verification at this school',
    },
};
